import Script from "next/script";
import React from "react";

interface CloudwatchRumSnippetProps {
  lob: string;
  school: string;
  program: string;
  application: string;
}

const {
  RUM_REGION,
  RUM_IDENTITY_POOL_ID,
  RUM_CLIENT_ID,
  RUM_DOMAIN,
  ENABLE_RUM,
} = process.env;

export const CloudwatchRumSnippet: React.FC<CloudwatchRumSnippetProps> = ({ lob, school, program, application }) => {
  // Error on build if we do not have a lob for a given page.
  if (!lob || !school || !program) {
    throw new Error('CloudwatchRumSnippet: Missing lob, school or program');
  }

  return (
    <>
      {ENABLE_RUM === 'true' &&
        (
          <Script id="cloudwatch-rum">
            {`
              (function initRum() {
                const config = {
                  sessionSampleRate: 1,
                  identityPoolId: "${RUM_REGION}:${RUM_IDENTITY_POOL_ID}",
                  endpoint: "https://dataplane.rum.${RUM_REGION}.amazonaws.com",
                  telemetries: ["http","errors","performance"],
                  allowCookies: true,
                  enableXRay: true,
                  sessionAttributes: {
                    lob: "${lob}",
                    school: "${school}",
                    program: "${program}",
                    application: "${application}"
                  }
                };

                ${RUM_DOMAIN ? `config.sessionAttributes.domain = '${RUM_DOMAIN}';` : ''}
                ${RUM_DOMAIN ? `config.sessionAttributes.actualDomain = window.location.origin;` : ''}

                const value = "; " + document.cookie;
                const parts = value.split('; tglr_sess_id=');

                if (parts.length === 2) {
                  config.sessionAttributes.tglrSessionId = parts.pop().split(';')[0];
                } else {
                  window.cohesion('ready', function () {
                    cwr('addSessionAttributes', {
                      tglrSessionId: _Cohesion?.sessionId || ''
                    });
                  });
                }

                (function(n,i,v,r,s,c,x,z){x=window.AwsRumClient={q:[],n:n,i:i,v:v,r:r,c:c};window[n]=function(c,p){x.q.push({c:c,p:p});};z=document.createElement('script');z.async=true;z.src=s;document.head.insertBefore(z,document.head.getElementsByTagName('script')[0]);})(
                  'cwr',
                  '${RUM_CLIENT_ID}',
                  '1.0.0',
                  '${RUM_REGION}',
                  'https://client.rum.${RUM_REGION}.amazonaws.com/1.18.0/cwr.js',
                  config
                );
              }())
            `}
          </Script>
        )
      }
    </>
  );
};
